import { render } from "./NotificationItemSkeleton.vue?vue&type=template&id=1743c8a2"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__